"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Accordion = __importStar(require("@radix-ui/react-accordion"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const AwardModal_1 = __importDefault(require("./AwardModal"));
const Award_1 = require("./Award/Award");
const utils_1 = require("../../../helpers/utils");
const dayjs_1 = __importDefault(require("dayjs"));
const MyAwards = ({ data }) => {
    const [clickedAward, setClickedAward] = (0, react_1.useState)();
    const groupedAwards = (0, react_1.useMemo)(() => {
        const obtainedAwards = data ? data.filter((a) => !!a.obtainedAt) : [];
        const sortAwards = (0, lodash_1.orderBy)(obtainedAwards.map((a) => (Object.assign(Object.assign({}, a), { obtainedAt: (0, dayjs_1.default)(a.obtainedAt).format('YYYY-MM-DD HH:mm:ss') }))), ['obtainedAt', 'priority'], ['desc', 'asc']);
        const latestAwards = (0, lodash_1.take)(sortAwards, 6);
        const grouped = (0, lodash_1.groupBy)(data, (award) => award.category);
        const endurance = grouped.endurance ? (0, lodash_1.sortBy)(grouped.endurance, 'requiredValue') : [];
        const bloodDonation = grouped['blood-donation']
            ? (0, lodash_1.sortBy)(grouped['blood-donation'], 'requiredValue')
            : [];
        const shares = grouped.shares ? (0, lodash_1.sortBy)(grouped.shares, 'requiredValue') : [];
        // sort by priotity, then by obtainedAt is not null to show obtained awards first
        const bonusAssignments = grouped['bonus-assignments']
            ? _.chain(grouped['bonus-assignments'])
                .filter((assignment) => assignment.obtainedAt !== null)
                .sortBy('priority')
                .concat(_.chain(grouped['bonus-assignments'])
                .filter((assignment) => assignment.obtainedAt === null)
                .sortBy('priority')
                .value())
                .value()
            : [];
        return {
            'latest-awards': latestAwards,
            'blood-donation': bloodDonation,
            endurance,
            shares,
            'bonus-assignments': bonusAssignments,
        };
    }, [data]);
    const awardCategories = (0, react_1.useMemo)(() => 
    // Get keys from groupedAwards, latest-awards should be first
    Object.keys(groupedAwards).sort((a, b) => {
        if (a === 'latest-awards') {
            return -1;
        }
        if (b === 'latest-awards') {
            return 1;
        }
        return 0;
    }), [groupedAwards]);
    const onModalClose = (0, react_1.useCallback)(() => {
        setClickedAward(undefined);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "bg-white shadow-sm container", id: "my-awards", children: (0, jsx_runtime_1.jsxs)("div", { className: "row", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col-12", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-black section-title", "aria-hidden": "true", children: __.trans('awards.my-awards-title') }), (0, jsx_runtime_1.jsxs)("h2", { className: "visually-hidden", children: [" ", __.trans('aria.my-awards-heading2')] })] }), (0, jsx_runtime_1.jsx)("div", { className: "col-12", children: (0, jsx_runtime_1.jsx)(Accordion.Root, { type: "multiple", defaultValue: ['latest-awards'], className: "accordion", children: awardCategories.map((value) => ((0, jsx_runtime_1.jsxs)(Accordion.Item, { value: value, className: "accordionItem", children: [(0, jsx_runtime_1.jsx)(Accordion.Header, { className: "accordionHeader text-black", children: (0, jsx_runtime_1.jsxs)(Accordion.Trigger, { className: "accordionTrigger", children: [(0, jsx_runtime_1.jsx)("span", { className: "accordion-header-span", children: __.trans(`awards.${value}`) }), (0, jsx_runtime_1.jsx)("i", { className: "icon icon-geblod_ikon_cheveron-down" })] }) }), (0, jsx_runtime_1.jsx)(Accordion.Content, { className: "accordionContent", children: (0, jsx_runtime_1.jsx)("div", { className: "awards", children: (0, lodash_1.map)(groupedAwards[value], (award) => ((0, jsx_runtime_1.jsx)(Award_1.Award, { award: award, color: (0, utils_1.getAwardColor)(award), onClick: () => setClickedAward(award), "aria-hidden": false }, `${award.id}-${award.key}`))) }) })] }, value))) }) })] }) }), clickedAward && ((0, jsx_runtime_1.jsx)(AwardModal_1.default, { open: !!clickedAward, award: clickedAward, onCloseCallback: onModalClose }))] }));
};
exports.default = MyAwards;
